import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)(({ theme, insideChat }) => ({
    height: `calc(100% - 48px)`,
    display: "grid",
    gridTemplateRows: insideChat ? "1fr" : "56px 1fr",
    border: "none",
    boxShadow: "none",
    [theme.breakpoints.down('sm')]: {
        height: '100%',
        gridTemplateRows: "1fr" // No BottomNavigation header row on mobile
    },
    // On an iPad in portrait it is a card over the page, like the internal chat.
    "html[data-tablet-portrait] &": {
        height: "calc(100% - 24px)",
        margin: theme.spacing(1.5),
        overflow: "hidden",
        borderRadius: 12,
        border: theme.neoUI?.effects?.contour?.main,
        boxShadow: theme.neoUI?.effects?.glow?.main,
    },
}));

export default TicketAdvancedLayout;